import { Pipe, PipeTransform } from '@angular/core';
import { LanguageService } from '@core/services/language.service';

const DIVISIONS: { amount: number; unit: Intl.RelativeTimeFormatUnit }[] = [
    {amount: 60, unit: 'seconds'},
    {amount: 60, unit: 'minutes'},
    {amount: 24, unit: 'hours'},
    {amount: 7, unit: 'days'},
    {amount: 4.34524, unit: 'weeks'},
    {amount: 12, unit: 'months'},
    {amount: Number.POSITIVE_INFINITY, unit: 'years'},
];

@Pipe({
    name: 'relativeTime',
    pure: false,
})
export class RelativeTimePipe implements PipeTransform {

    constructor(private languageService: LanguageService) {}

    transform(value: string | Date | null | undefined): string {
        if (!value) {
            return '';
        }

        const date = typeof value === 'string' ? new Date(value) : value;

        if (isNaN(date.getTime())) {
            return '';
        }

        const rtf = new Intl.RelativeTimeFormat(this.languageService.currentLang.code, {numeric: 'auto'});

        let duration = (date.getTime() - Date.now()) / 1000;

        for (const division of DIVISIONS) {
            if (Math.abs(duration) < division.amount) {
                return rtf.format(Math.round(duration), division.unit);
            }
            duration /= division.amount;
        }

        return '';
    }
}
